
import request from '@/request'
const part_url = 'news/web/article/';


function enterpriseList(data) {
  let url = part_url + "enterpriseList";
  return request.get(url, data)
}
/**
 * 查询咨询
 *
 * @param {*} categoryId 分类id
 * @param {*} pageNow 当前页
 * @param {*} pageSize 页容
 * @param {*} title 标题
 * @returns
 */
function articleList(data) {
  let url = part_url + "articleList";
  return request.get(url, data)
}
/**
 * 查询详情
 *
 * @param {*} id 新闻id
 * @returns
 */
function getById(data) {
  let url = part_url + "getById";
  return request.get(url, data)
}

/**
 * 查询所有分类
 */
 function articleCategoryList(data) {
  let url = part_url + "articleCategoryList";
  return request.get(url, data)
}

/**
 * 查询树形结构的数据
 * @param {*} data 
 * @returns 
 */
function articleTreeList(data) {
  let url = part_url + "articleTreeList";
  return request.get(url, data)
}


/**
 * 点击查询详情
 * @param {*} data 
 * @returns 
 */
function handlerNavigationParticulars(data) {
  let url = part_url + "getByIdParticulars";
  return request.get(url, data);
}

export default {
  enterpriseList,
  articleList,
  getById,
  articleCategoryList,
  articleTreeList,
  handlerNavigationParticulars,
}



// WEBPACK FOOTER //
// ./src/api/news.js